<template>
  <div class="layout">
    <el-container style="height: 100vh">
      <!-- 侧边栏 -->
      <el-aside width="165px" style="background-color: var(--theme-color); color: #fff;height:100vh;" class="flex flex-column justify-content-between">
        <div>
          <div style="padding: 50px 20px; font-size: 18px; color: rgb(0 81 106);" class="text-center">AI数智全擎</div>
          <el-menu
            :default-active="$route.path"
            class="el-menu-vertical-demo"
            text-color="#000000"
            active-text-color=" var(--theme-text-color)"
            router
          >
            <el-menu-item index="/">
              <i class="el-icon-document-checked"></i>
              <span>文字校对</span>
            </el-menu-item>
            <!-- <el-menu-item index="/word">
              <i class="el-icon-document"></i>
              <span>文档校对</span>
            </el-menu-item> -->
            <el-menu-item index="/writing">
              <i class="el-icon-edit"></i>
              <span>AI写作</span>
            </el-menu-item>
            <el-menu-item index="/imagecheck">
              <i class="el-icon-picture-outline"></i>
              <span>图片审查</span>
            </el-menu-item>
            <el-menu-item index="/videocheck">
              <i class="el-icon-video-camera"></i>
              <span>视频审查</span>
            </el-menu-item>
            <el-menu-item index="/image">
              <i class="el-icon-picture-outline-round"></i>
              <span>图像生成</span>
            </el-menu-item>
            <el-menu-item index="/video">
              <i class="el-icon-video-play"></i>
              <span>视频生成</span>
            </el-menu-item>
            <el-menu-item index="/media">
              <i class="el-icon-edit-outline"></i>
              <span>媒体发文</span>
            </el-menu-item>
          </el-menu>
        </div>

        <!-- 底部登录按钮 -->
        <div style="padding: 100px 20px; text-align: center;">
          <el-button
            type="primary"
            size="medium"
            round
            icon="el-icon-user-solid"
            style="background-color: #000000;border:none;"
            @click="toUserCenter"
            v-if="userInfo"
          >
            个人中心
          </el-button>
          <el-button
            type="primary"
            size="medium"
            round
            icon="el-icon-user-solid"
            style="background-color: #000000;border:none;"
            @click="toLogin"
            v-else
          >
            登录/注册
          </el-button>
        </div>
      </el-aside>

      <!-- 主体内容 -->
      <el-container>
        <!-- <el-header class="headers">
          
        </el-header> -->
        <el-main style="padding:0;">
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>


export default {
  name: 'Layout',
  computed: {
    // 从 Vuex 获取用户信息
    userInfo() {
      return this.$store.state.userInfo;
    }
  },
  methods: {
    toUserCenter(){
      if (this.$route.path !== '/usercenter') {
        this.$router.push('/usercenter')
      }
    },
    toLogin() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
:root {
  --theme-color: #E6EDFF;
  --theme-text-color: rgb(0 81 106);
}

.layout {
  height: 100vh;
}

.el-menu-item {
  background-color: var(--theme-color) !important;
}
.el-menu-item:hover {
  background-color: rgb(167, 227, 255) !important;
}
.headers {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--theme-color);
}
</style>
